/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable , BehaviorSubject} from 'rxjs';
import {AppConfig} from '../../app.config';
@Injectable()
export class OrganizationsService  {
  organizations: any[];
  onOrganizationsChanged: BehaviorSubject<any> = new BehaviorSubject({});
  countryId = '';
  citiesId = [];
  organizationonsId = [];
  addSuccess = false;
  updateSuccess = false;

  constructor (private http: HttpClient , private api: AppConfig) {

  }

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve (route: ActivatedRouteSnapshot , state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    return new Promise<void>((resolve , reject) => {

      Promise.all([
        this.countryId = '' ,
        this.citiesId = [] ,
        this.getOrganizations()
      ]).then(
        () => {
          resolve();
        } ,
        reject
      );
    });
  }

  getOrganizations () {
    return new Promise((resolve , reject) => {
      this.http.get(this.api.baseUrl + '/organization/organizations?countryId=' + this.countryId +
        '&citiesId=' + this.citiesId.toString() , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.organizations = response.map(el => {
            if (el.city && el.city[0]) {
              let cities = '';
              for (let i = 0; i < el.city.length; i++) {
                cities = cities + el.city[i].name;
                if (i + 1 !== el.city.length) {
                  cities = cities + ', ';
                }
              }
              el.cities = cities;
            }
            return el;
          });
          // this.organizations = response;
          this.onOrganizationsChanged.next(this.organizations);
          resolve(this.organizations);
        } , reject);
    });

  }

  getGuestOrganization () {
    return this.http.get(this.api.baseUrl + '/organization/getGuestOrganization' , this.api.jsonTokenHeaders);
  }

  getOrganizationById (id) {
    return this.http.get(this.api.baseUrl + '/organization/organization?id=' + id , this.api.jsonTokenHeaders);
  }

  getCompetenciesByOrganizationId (id) {
    return this.http.get(this.api.baseUrl + '/organization/getCompetenciesByOrganizationId?orgId=' + id , this.api.jsonTokenHeaders);
  }

  updateCompetencyStatus (id, status) {
    return this.http.get(this.api.baseUrl + '/organization-competency/updateEnabled?id=' + id + '&newStatus=' + status,
      this.api.jsonTokenHeaders);
  }

  deleteOrganization (id) {
    return this.http.delete(this.api.baseUrl + '/organization/deleteOrganization?id=' + id , this.api.jsonTokenHeaders);
  }

  addOrganization (data) {
    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[ key ]) {
        formData.append(key , data[ key ]);
      }
    }
    if (data.hasOwnProperty('whatsapp')) {
      formData.delete('whatsapp');
      formData.append('whatsapp' , data.whatsapp ? '1' : '0');
    }
    if (data.hasOwnProperty('isTest')) {
      formData.delete('isTest');
      formData.append('isTest' , data.isTest ? '1' : '0');
    }
    if (data.hasOwnProperty('allowCompetency')) {
      formData.delete('allowCompetency');
      formData.append('allowCompetency' , data.allowCompetency ? '1' : '0');
    }
    if (data.hasOwnProperty('allowTimeAndBudget')) {
      formData.delete('allowTimeAndBudget');
      formData.append('allowTimeAndBudget' , data.allowTimeAndBudget ? '1' : '0');
    }
    if (data.hasOwnProperty('allowGuestEvent')) {
      formData.delete('allowGuestEvent');
      formData.append('allowGuestEvent' , data.allowGuestEvent ? '1' : '0');
    }
    return this.http.post(this.api.baseUrl + '/organization/addOrganization' , formData , this.api.formDataHeaders);
  }

  getCountry () {
    return this.http.get(this.api.baseUrl + '/country/countries' , this.api.jsonTokenHeaders);
  }

  getCity (id) {
    return this.http.get(this.api.baseUrl + '/city/cityByCountry?id=' + id , this.api.jsonTokenHeaders);
  }

  getOrganizationType () {
    return this.http.get(this.api.baseUrl + '/organizationType/organizationTypes' , this.api.jsonTokenHeaders);
  }

  getOrganizationByCantonId (id) {
    return this.http.get(this.api.baseUrl + '/organization/organizationByCantons?cantons=' + id.toString() , this.api.jsonTokenHeaders);
  }

  getOrganizationByCity (id) {
    return this.http.get(this.api.baseUrl + '/organization/organizationByCity?id=' + id , this.api.jsonTokenHeaders);
  }

  getUserByOrganization (id) {
    return this.http.get(this.api.baseUrl + '/user/userByOrganisation?id=' + id , this.api.jsonTokenHeaders);
  }

  getTagByOrganization (id) {
    return this.http.get(this.api.baseUrl + '/tag/tagsByOrganization?id=' + id , this.api.jsonTokenHeaders);
  }

  checkOrganizationPlatform(id) {
    return this.http.get(this.api.baseUrl + '/organization/checkOrganizationPlatform?platformId=6&id=' + id , this.api.jsonTokenHeaders);
  }

  getPlatformsByOrganizationId(id) {
    return this.http.get(this.api.baseUrl + '/organization/getPlatformsByOrganizationId?id=' + id , this.api.jsonTokenHeaders);
  }

  getDynamicData (lang) {
    return this.http.get(this.api.baseUrl + '/dynamicData/dynamicDatas?lang=' + lang , this.api.jsonTokenHeaders);
  }

  getDynamicDataOrg (id) {
    return this.http.get(this.api.baseUrl + '/dynamicOrgData/dynamicOrgDatas?orgId=' + id , this.api.jsonTokenHeaders);
  }

  getAdminRates (id) {
    return this.http.get(this.api.baseUrl + '/adminRate/adminRates?orgId=' + id , this.api.jsonTokenHeaders);
  }

  getAdminType (id) {
    return this.http.get(this.api.baseUrl + '/user/userTypeByOrg?orgId=' + id , this.api.jsonTokenHeaders);
  }

  getWizzardData (id) {
    return this.http.get(this.api.baseUrl + '/organization/wizzardData?id=' + id , this.api.jsonTokenHeaders);
  }

  getOrganizationForFollowing () {
    return this.http.get(this.api.baseUrl + '/organization/getOrganizationForFollowing?platformId=6', this.api.jsonTokenHeaders);
  }

  getFollowingOrganization (frontUserId) {
    return this.http.get(this.api.baseUrl + '/followOrganization/getFollowOrganization?frontUserId=' + frontUserId, this.api.jsonTokenHeaders);
  }

  deleteFollowOrganization (id) {
    return this.http.get(this.api.baseUrl + '/followOrganization/deleteFollowOrganization?id=' + id, this.api.jsonTokenHeaders);
  }

  addFollowOrganization (data) {
    return this.http.post(this.api.baseUrl + '/followOrganization/addFollowOrganization', data , this.api.jsonTokenHeaders);
  }

  getOldEvent (id, orgId) {
    return this.http.get(this.api.baseUrl + '/gbStgallenAngebot/gbStgallenAngebots?id=' + id  + '&orgId=' + orgId, this.api.jsonTokenHeaders);
  }

  getOldUser (id, orgId) {
    return this.http.get(this.api.baseUrl + '/gbStgallenPerson/gbStgallenPersons?id=' + id  + '&orgId=' + orgId, this.api.jsonTokenHeaders);
  }
  setDynamicOrgData (data, id) {
    data.organizationId = id;
    return this.http.post(this.api.baseUrl + '/dynamicOrgData/activeDynamicOrgData', data , this.api.jsonTokenHeaders);
  }

  changeDynamicOrgData (data) {
    data.active = !data.active;
    return this.http.post(this.api.baseUrl + '/dynamicOrgData/addDynamicOrgData', data , this.api.jsonTokenHeaders);
  }

  updateAdminRates (data) {
    return this.http.post(this.api.baseUrl + '/adminRate/addAdminRate', data , this.api.jsonTokenHeaders);
  }

  addDynamicDataOrg (data) {
    return this.http.post(this.api.baseUrl + '/dynamicOrgData/addDynamicOrgData', data , this.api.jsonTokenHeaders);
  }

  importEvent (data) {
    return this.http.post(this.api.baseUrl + '/event/importEvent', data , this.api.jsonTokenHeaders);
  }

  importUser (data) {
    return this.http.post(this.api.baseUrl + '/frontUser/wizzardUser', data , this.api.jsonTokenHeaders);
  }
  deleteDynamicDataOrg(id) {
    return this.http.delete(this.api.baseUrl + '/dynamicOrgData/deleteDynamicOrgData?id=' + id , this.api.jsonTokenHeaders);
  }
  setCountryId (id) {
    this.countryId = id;
    this.citiesId = [];
    // console.log(this.countryId);
    // console.log(this.citiesId);
  }

  setCities (city) {
    if (city.selected) {
      this.citiesId.push(city.canton);
    } else {
      const index = this.citiesId.indexOf(city.canton);
      if (index !== -1) {
        this.citiesId.splice(index , 1);
      }
    }
    // console.log(this.countryId);
    // console.log(this.citiesId);
  }

  getCities () {
    return this.citiesId;
  }

  setOrganizations (organization) {
    if (organization.selected) {
      this.organizationonsId.push(organization.organization);
    } else {
      const index = this.organizationonsId.indexOf(organization.organization);
      if (index !== -1) {
        this.organizationonsId.splice(index , 1);
      }
    }
  }

}
